<div class="animated fadeInRight" style="padding: 24px;">

  <div class="row no-padding invite-row">
    <mat-form-field appearance="fill" class="input-field invite-field">
      <input matInput [(ngModel)]="this.email" style="margin: 0px" [required]
        placeholder="{{'Email' | translate}}">
        <mat-icon matSuffix style="color: grey;">mail</mat-icon>
      </mat-form-field>

      <button mat-flat-button color="primary"
        [disabled]="!this.validateemail(this.email)"
        (click)="AddLogin()" class="button-standard invite-button">
        {{'Einladen' | translate}}
      </button>
    </div>

    @if (this.email.length > 5 && !this.validateemail(this.email)) {
      <mat-warning class="email-warning">
        {{'Login.EmailFormatUngültig' | translate}}
      </mat-warning>
    }

    @if (isLoading) {
      <div>
        <mat-progress-bar mode="indeterminate" style="margin-top: 4px; margin-bottom: 4px;"></mat-progress-bar>
      </div>
    }

    @if (!isLoading && oroservice.kundeninfo && oroservice.kundeninfo.Logins && oroservice.kundeninfo.Logins.length == 0) {
      <div class="row no-padding">
        {{'NoResult' | translate}}
      </div>
    }

    @if (!isLoading && oroservice.kundeninfo && oroservice.kundeninfo.Logins && oroservice.kundeninfo.Logins.length > 0) {
      <div class="row no-padding">
        <table mat-table [dataSource]="oroservice.kundeninfo.Logins" style="width: 100%; max-width: 960px"
          class="mat-elevation-z2">
          <ng-container matColumnDef="Email">
            <mat-header-cell *matHeaderCellDef>{{'Email' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
            {{element.email}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="AccessType">
            <mat-header-cell *matHeaderCellDef>{{'Verwaltung.AccessType' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ getAccessType(element.isMaster) | translate }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="Status">
            <mat-header-cell *matHeaderCellDef>{{'Status' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              @if (element.Status == 0) {
                <mat-icon style="font-size: 22px;">schedule</mat-icon>
              }
              @if (element.Status == 1) {
                <mat-icon style="color: rgb(136, 219, 12); font-size: 22px;;">circle</mat-icon>
              }
              @if (element.Status == 2) {
                <mat-icon style="color: red; font-size: 22px;">circle</mat-icon>
              }
            <!-- {{element.status ==1 ?('EmailAktiv' | translate):('EmailInaktiv' | translate) }}</mat-cell> -->
          &nbsp;{{ getActivityMessage(element.status) | translate }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Tools">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            @if (!element.isMaster) {
              <mat-icon
                (click)="this.DeleteLogin(element)"
                style="cursor: pointer;"
              matTooltip="{{ 'Verwaltung.RemoveMouseOver' | translate }}">delete</mat-icon>
            }
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="emailColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: emailColumns;"></mat-row>
      </table>
    </div>
  }
</div>
